import { jsx as K } from "react/jsx-runtime";
import a from "next/legacy/image";
const r = (C) => {
  const { width: A, height: o, ...g } = C, t = typeof A == "string" ? Number(A == null ? void 0 : A.replace("px", "")) : A, e = typeof o == "string" ? Number(o == null ? void 0 : o.replace("px", "")) : o;
  return /* @__PURE__ */ K(
    a,
    {
      ...g,
      width: t,
      height: e,
      blurDataURL: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAADAAQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAADAAMBAQAAAAAAAAAAAAABAgMABAURUf/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAECEf/aAAwDAQACEQMRAD8Anz9voy1dCI2mectSE5ioFCqia+KCwJ8HzGMZPqJb1oPEf//Z",
      placeholder: "blur"
    }
  );
}, m = r;
export {
  m as default
};
